<template>
	<div class="video-cover" @click="click">
		<img v-if="img" :src="img" :alt="title" :title="title" class="img-f">
		<div class="video-cover-mask" v-if="img"></div>
		<div class="video-cover-button" v-if="!isAudio">
			<div class="video-cover-title" v-if="title">{{title}}</div>
			<div class="video-cover-length" v-if="length">{{length | formatSeconds}}</div>
		</div>
	</div>
</template>

<script>
import formatSeconds from '../../../filters/format-seconds-2'

export default {
  props: ['img', 'title', 'isAudio', 'length'],
  data () {
    return {}
  },
  filters: {
    formatSeconds
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
	@charset "utf-8";
	@import '../../../style/main';

	$global-width: 750;

	.video-cover {
		@include afull;
		background-color: rgba(#000, .35);
		z-index: 10;
		&-mask {
			@extend .video-cover;
		}
		&-button {
			@include center-absolute(67);
			background-image: url('./img/button.png?__inline');
			background-size: 100% 100%;
		}
		&-title {
			@include center-absolute(500, null, -100%);
			@include height(36);
			font-family: '黑体';
			text-align: center;
			font-size: use(34);
			color: #fff;
		}
		&-length {
			@include center-absolute(500, null, 120%);
			@include height(24);
			font-family: '黑体';
			text-align: center;
			font-size: use(24);
			color: #fff;
		}
	}

	$global-width: 720;
</style>
